import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AchievementProvider } from '@providers/achievement/achievement';
import { AuthProvider } from '@providers/auth/auth';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { ASSETS } from '@env';
import { ModalInsigniaComponent } from '../../components/modal-insignia/modal-insignia';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';

@Component({
  selector: 'page-achievements',
  templateUrl: 'achievements.html',
})
export class AchievementsPage {

  jugador: Jugador;
  equipo: Equipo;
  insignias: Array<any> = [];
  insigniasRequest: Boolean = true;
  ICONS_ACHIEVEMENTS = ASSETS.ICONS_ACHIEVEMENTS;
  insigniaModal: any;
  @ViewChild(ModalInsigniaComponent) modalInsignias: ModalInsigniaComponent;
  campaign: any;
  insigniasNuevas: Array<any> = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public achievementProvider: AchievementProvider,
    private authProvider: AuthProvider,
    private campaignsProvider: CampaignsProvider,
  ) {
  }

  async ionViewDidLoad() {
    this.campaign = await this.campaignsProvider.get();
    this.initRequest();
  }

  async initRequest(refresher = null) {
    this.insigniasRequest = true;
    try {
      this.modalInsignias.buscaNuevasInsignias();
      this.jugador = await this.authProvider.getSession();
      this.equipo = await this.authProvider.getEquipo();
      this._getInsignias();

    } catch(e) {
      console.log(e);
    } finally {
      if ( refresher ) {
        refresher.complete();
      }

    }

  }

  private async _getInsignias() {
    try {
      this.insigniasRequest = true;
      this.insignias = await this.achievementProvider.getAll(this.equipo.area._id, this.equipo._id, this.jugador._id);
    } catch(e) {
      console.log(e);
    } finally {
      this.insigniasRequest = false;
    }
  }

  muestraModal(insignia: any) {
    this.modalInsignias.present(insignia);
  }

  close() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/achievements/achievements.ts